import "./bootstrap";

import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import mainStore from "./store";
import {ServerTable,} from "vue-tables-2";
import VueToastr from "@deveodk/vue-toastr";
import VueInputMask from "vue-inputmask";
import vSelect from "vue-select";

import "./assets/css/integration-logs.css";

import Lightbox from 'vue-easy-lightbox'

Vue.use(Lightbox)

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

Vue.component("v-select", vSelect);


Vue.use(VueInputMask.default);

import VueMask from "v-mask";

Vue.use(VueMask);

import VueTheMask from "vue-the-mask";

Vue.use(VueTheMask);

import {VueMaskDirective} from 'v-mask'

Vue.directive('mask', VueMaskDirective);

import {
    VueMaskFilter
} from "v-mask";

Vue.filter("VMask", VueMaskFilter);

const translation = {
    count: "Mostrando {from} de {to} até {count} de registros",
    filter: "Pesquisar:",
    filterPlaceholder: "Pesquisar",
    limit: "Registros:",
    noResults: "Nenhum registro encontrado",
    page: "Página:",
    filterBy: "Filtrar por {column}"
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'SelectSearch {column}'
    // default option for list filters }
};

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios
            .get(this.url, {
                params: data
            })
            .catch(
                function (e) {
                    this.dispatch("error", e);
                    router.push("/login");
                }.bind(this)
            );
    },
    texts: translation,
    pagination: {
        chunk: 15,
        dropdown: false,
        nav: "scroll"
    },
    perPage: 10,
    perPageValues: [10, 25, 50, 100]
};

import http from "./http";

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(router);
Vue.use(ServerTable, options, true, "bootstrap3", "footerPagination");
Vue.use(VueToastr);

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: {
        App
    },
    template: "<App/>",
    created() {
        this.$store.dispatch("initialize");
    }
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">
*/

import "./assets/auxiliary/bootstrap/css/bootstrap.css";
import "../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import "./assets/css/style.css";
import "./assets/css/form.css";
import "./assets/css/crud.css";
import "./assets/auxiliary/animate/animate.css";
import "./assets/auxiliary/chosen/chosen.min.js";
import "./assets/auxiliary/chartjs/Chart.min.js";
import "./assets/auxiliary/chartjs/utils.js";
import "../node_modules/mixitup/dist/mixitup.min.js";
import "./assets/auxiliary/fontawesome/css/all.min.css";
import "./assets/js/plugins/metisMenu/jquery.metisMenu";
import "../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
import "../node_modules/vue-select/dist/vue-select.css";
import "../node_modules/vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import swal from "sweetalert";

var filter = function (text, length, clamp) {
    clamp = clamp || "...";
    var node = document.createElement("div");
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

// Vue.prototype.$http = window.axios;
// alterar chamadas para http
Vue.prototype.$http = http;
Vue.prototype.$message = function (title, msg, type) {

    if (msg.message != 'Token has expired') {
        let newMsg = "";
        if (msg instanceof Object) {
            newMsg += "<ul>";
            for (var key in msg) {
                if (msg.hasOwnProperty(key)) {
                    newMsg += "<li>";
                    newMsg += msg[key];
                    newMsg += "</li>";
                }
            }
            newMsg += "</ul>";
        } else newMsg = msg;

        this.$toastr("add", {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: "toast-top-right",
            type: type
        });
    }
};



// WEBPACK FOOTER //
// ./src/main.js